import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './Button';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing.lg};
  max-width: 420px;
  margin: ${props => props.theme.spacing.xl} auto;
  text-align: center;
`;

const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: ${props => props.theme.borderRadius.lg};
  background: ${props => props.theme.colors.danger}12;
  color: ${props => props.theme.colors.danger};
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const Title = styled.p`
  font-size: ${props => props.theme.typography.sizes.medium};
  font-weight: 600;
  color: ${props => props.theme.colors.text};
  margin: 0 0 ${props => props.theme.spacing.sm} 0;
`;

const Description = styled.p`
  font-size: ${props => props.theme.typography.sizes.small};
  color: ${props => props.theme.colors.muted};
  line-height: 1.5;
  margin: 0 0 ${props => props.theme.spacing.lg} 0;
`;

export const ErrorState = ({ title, message, onRetry, theme }) => {
  return (
    <Wrapper theme={theme}>
      <IconWrap theme={theme}>
        <AlertTriangle size={28} />
      </IconWrap>
      <Title theme={theme}>{title || 'Something went wrong'}</Title>
      {message && <Description theme={theme}>{message}</Description>}
      {onRetry && (
        <Button variant="secondary" theme={theme} onClick={onRetry}>
          <RefreshCw size={16} style={{ marginRight: 6 }} />
          Try again
        </Button>
      )}
    </Wrapper>
  );
};
